import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'
import PhotoComponent from './mentors-photo-url.component'



export default function MentorsInfoComponent({ handleInnerFormChange, selectedMentors,changeImage  }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

 <InputContainer
              label="Degree"
              name="Degree"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorInfo.Degree',
                  selectedMentors?.MentorInfo
                )
              }}
              type="text"
              value={selectedMentors?.MentorInfo?.Degree}
            />

             <InputContainer
              label="Department"
              name="Department"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorInfo.Department',
                  selectedMentors?.MentorInfo
                )
              }}
              type="text"
              value={selectedMentors?.MentorInfo?.Department}
            />

             <InputContainer
              label="Research Area"
              name="ResearchArea"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorInfo.ResearchArea',
                  selectedMentors?.MentorInfo
                )
              }}
              type="text"
              value={selectedMentors?.MentorInfo?.ResearchArea}
            />


             <InputContainer
              label="Institution Name"
              name="InstitutionName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorInfo.InstitutionName',
                  selectedMentors?.MentorInfo
                )
              }}
              type="text"
              value={selectedMentors?.MentorInfo?.InstitutionName}
            />

            <InputContainer
              label="Biography"
              name="Biography"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorInfo.Biography',
                  selectedMentors?.MentorInfo
                )
              }}
              type="text"
              value={selectedMentors?.MentorInfo?.Biography}
            />

            <InputContainer
              label=" Mentor Verified"
              name="IsMentorVerified"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'MentorInfo.IsMentorVerified',
                  selectedMentors?.MentorInfo
                )
              }}
              type="checkbox"
              value={selectedMentors?.MentorInfo?.IsMentorVerified}
            />

        
           

            






         </div>
         }
             expandedPanel="userInfo"
             headerTitle="Mentor Info"
         />
         <AccordionContainer
                           child={
                             <div>
                                 <PhotoComponent
                                 selectedMentors={selectedMentors}
                                 changeImage={changeImage}
                                 />
                               
                             </div>
                           }
                           expandedPanel="logo"
                           headerTitle="Photo Info"
                         />
                           </>
  )
}